import { makeApiCall } from "../apirequest";

export default({
  state: {
    realtors: [],
    // realtorPaymentHistory: [],  
  },
  getters: {
    getRealtors: (state) => state.realtors,
    // getRealtorPaymentHistory: (state) => state.realtorPaymentHistory,
  },
  mutations: {
    SET_REALTORS(state, realtors) {
      state.realtors = realtors;
    },
    // SET_REALTOR_PAYMENT_HISTORY(state, realtorPaymentHistory) {
    //   state.realtorPaymentHistory = realtorPaymentHistory;
    // },
  },
  actions: {
    async getRealtors({ commit }, payload) {
      const response = await makeApiCall('Admin/GetUsersForAdmin', 'POST', payload);
      if (!response.error) {
        commit('SET_REALTORS', response.data.data);
      }
      return response;
    },
  },
  // async getRealtorPaymentHistory({ commit }, payload) {
  //   const response = await makeApiCall(`User/GetUserSubcriptionDetail?UserId=${payload.UserId}`, 'POST');
  //   if (!response.error) {
  //     commit('SET_REALTOR_PAYMENT_HISTORY', response.data.data);
  //   }
  //   return response;
  // },
});

